import type { PlayerProfile, PublicPlayerProfile } from "../schemas"

export function createFriendCode(): string {
  const token = crypto
    .randomUUID()
    .replace(/-/gu, "")
    .slice(0, 10)
    .toUpperCase()
  return `CF-${token}`
}

export function buildPublicPlayerProfile(
  profile: PlayerProfile,
  ownerUserId: string,
  avatarUrl?: string | null,
  publishedAt: string = new Date().toISOString(),
): PublicPlayerProfile {
  return {
    ownerUserId,
    gamerTag: profile.gamerTag,
    gamerTagNormalized: profile.gamerTagNormalized,
    avatarUrl: avatarUrl ?? undefined,
    friendCode: profile.friendCode,
    role: profile.role,
    createdAt: profile.createdAt,
    updatedAt: publishedAt,
  }
}
